import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";
import { EnvErrorBoundary } from "./components/EnvErrorBoundary";
import { ThemeProvider } from "./providers/theme-provider";

createRoot(document.getElementById("root")!).render(
  <EnvErrorBoundary>
    <ThemeProvider>
      <App />
    </ThemeProvider>
  </EnvErrorBoundary>
);
